<template lang="html">
  <UPopover v-if="terms">
    <UButton
      icon="i-lucide-circle-help"
      color="neutral"
      variant="ghost"
      size="xs"
      square
      :aria-label="label"
    />

    <template #content>
      <p class="max-w-xs p-3 text-sm whitespace-pre-wrap text-muted">
        {{ terms }}
      </p>
    </template>
  </UPopover>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    terms?: string | null
    label?: string
  }>(),
  {
    label: 'Условия акции',
  },
)
</script>
